import React, {useRef} from "react";
import ReactQuill from "react-quill";
import {MAX_MESSAGE_LENGTH} from "../../../core/const";
import {getEditorTextLength} from "../../../core/utils";

/**
 * The setting describing which options are to be displayed to the user.
 */
const richtextToolbar = {
  toolbar: [
    ['bold'],
    [{ 'list': "bullet" }],
    ['link'],
    ['clean']
  ],
};

/**
 * The formats part defines the HTML types that can be present in the output.
 * Example: If I paste a content of a document from Word, all other tags will be striped.
 */
const formats = [
  'bold',
  'list', 'bullet',
  'link'
];

const MobileRichtextInput = ({ onChange, disabled, value }) => {

    const reactQuillRef = useRef();

    /**
     * Reports the new content together with its plain-text length (read straight
     * from the Quill editor, so no HTML parsing is needed) up to the parent.
     */
    const handleChange = (newValue, delta, source, editor) => {
        onChange(newValue, getEditorTextLength(editor));
    }

    // Derived from the live editor (no local state, so typing never triggers an
    // extra re-render that would reset the caret). The editor is not available on
    // the first render, which is fine because the input always starts empty.
    const charCount = getEditorTextLength(reactQuillRef.current?.getEditor());
    const limitReached = charCount > MAX_MESSAGE_LENGTH;

    return (
        <div className="richtext-wrapper">
            <ReactQuill
              id={"bubble-toolbar"}
              theme="bubble"
              ref={reactQuillRef}
              modules={richtextToolbar}
              formats={formats}
              value={value}
              readOnly={disabled ? true : false}
              onChange={handleChange} />
            <span className={"char-counter" + (limitReached ? " char-counter-limit" : "")}>
                {charCount}/{MAX_MESSAGE_LENGTH}
            </span>
        </div>
    );
}

export default MobileRichtextInput;